import { render } from "./ModalPreviewImg.vue?vue&type=template&id=4296a7b6"
import script from "./ModalPreviewImg.vue?vue&type=script&lang=js"
export * from "./ModalPreviewImg.vue?vue&type=script&lang=js"

import "./ModalPreviewImg.vue?vue&type=style&index=0&id=4296a7b6&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__